import React from 'react';
import { WebinarLink } from './WebinarLink';
export const Header = ({
  openModal
}) => {
  // Replace 'webinar' with WebinarLink component in text
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-106">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <header className="mb-8" data-id="element-107">
      <h1 className="text-2xl md:text-3xl font-bold text-center mb-6 text-blue-800 leading-tight" data-id="element-108">
        "De dominantie theorie geldt NIET voor honden" zegt de wetenschapper
        achter het onderzoek
      </h1>
      <div className="text-center mb-4 text-blue-600 font-semibold" data-id="element-109">
        Het is belangrijk dat de hondeneigenaren de waarheid leren
      </div>
      <div className="text-center text-sm text-gray-600 mb-6" data-id="element-110">
        Door Amee de Bruijn, Gedragsexpert en oprichtster van Stressless Dogs
      </div>
      <div className="w-full mb-6" data-id="element-111">
        <a href="https://stresslessdogs.nl/meta-mcc-adv" target="_blank" rel="noopener noreferrer" data-id="element-112">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eG9E2iBuG8JcQCzTP8jAc5/Scherm%C2%ADafbeelding_2025-09-01_om_18.33.38.png" alt="David L. Mech, de bioloog die de dominantie theorie heeft afgekeurd" className="w-full h-auto rounded-lg shadow-md cursor-pointer" data-id="element-113" />
        </a>
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-114">
          "Het is onjuist om de relatie tussen mens en hond te beschrijven als
          een strijd om dominantie" - David L. Mech
        </p>
      </div>
      <div className="w-full h-[1px] bg-gray-200 my-6" data-id="element-115"></div>
    </header>;
};